"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KodenAddDialog = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const koden_koden_dialog_1 = require("@scott/koden.koden-dialog");
const koden_koden_crud_1 = require("@scott/koden.koden-crud");
const getErrors_1 = __importDefault(require("./getErrors"));
const getDisabledOk_1 = __importDefault(require("./getDisabledOk"));
const useStateMap_1 = __importStar(require("./hooks/useStateMap"));
const DialogColumns_1 = __importDefault(require("./components/DialogColumns"));
const getHasError_1 = __importDefault(require("./getHasError"));
const KodenAddDialog = ({ title, columns, resource, open, onClose, onAddSuccess, }) => {
    const addMutation = (0, koden_koden_crud_1.useAddMutation)(resource);
    const [dirty, setDirty] = (0, react_1.useState)(false);
    const [stateMap, setStateMap] = (0, useStateMap_1.default)(columns);
    const [errorMsg, setErrorMsg] = (0, react_1.useState)("");
    const errors = (0, getErrors_1.default)(stateMap, columns);
    const hasError = (0, getHasError_1.default)(errors);
    const disabledOk = (0, getDisabledOk_1.default)({
        hasError,
        dirty,
        isLoading: addMutation.isLoading,
    });
    const onDialogClose = () => {
        setDirty(false);
        setStateMap((0, useStateMap_1.getEmptyStateMap)(columns));
        setErrorMsg("");
        onClose();
    };
    return (React.createElement(koden_koden_dialog_1.KodenDialog, { id: `Dialog_${resource}_add`, title: title, open: open, onClose: onDialogClose, onOk: () => {
            setDirty(true);
            if (!hasError) {
                addMutation.mutate(stateMap, {
                    onSuccess(data) {
                        onDialogClose();
                        if (onAddSuccess) {
                            onAddSuccess(data);
                        }
                    },
                    onError(data) {
                        setErrorMsg(data.response.data.msg);
                    },
                });
            }
        }, disabledOk: disabledOk, isLoading: addMutation.isLoading },
        React.createElement(DialogColumns_1.default, { columns: columns, setStateMap: setStateMap, disabled: addMutation.isLoading, dirty: dirty, errors: errors, errorMsg: errorMsg, stateMap: stateMap })));
};
exports.KodenAddDialog = KodenAddDialog;
exports.default = exports.KodenAddDialog;
//# sourceMappingURL=koden-add-dialog.js.map